import { deleteJson, get, postJson, putJson, upload } from '../../../common/data/common-data-service';
import {
    IInteriorOrganizerCategoriesResponse, IInteriorOrganizerItemsResponse,
    IInteriorOrganizerPlacesResponse
} from '../interior-organizer-interfaces';

// --------------- ITEM CATEGORIES -----------------------

export const getStorageItemCategoriesData = async () : Promise<IInteriorOrganizerCategoriesResponse|null> => {
    return await get(`/api/interior/items-storage-category/get-data`);
};

export const deleteCategory = async (id: number) : Promise<IInteriorOrganizerCategoriesResponse|null> => {
    return await deleteJson(`/api/interior/items-storage-category/delete`, {
        id
    });
};

export const insertCategory = async (
    name: string,
    description: string,
    color: string,
) : Promise<IInteriorOrganizerCategoriesResponse|null> => {
    return await postJson(`/api/interior/items-storage-category/insert`, {
        name,
        description,
        color,
    });
};

export const updateCategory = async (
    id: number,
    name: string,
    description: string,
    color: string,
) : Promise<IInteriorOrganizerCategoriesResponse|null> => {
    return await putJson(`/api/interior/items-storage-category/update`, {
        id,
        name,
        description,
        color,
    });
};

// --------------- STORAGE PLACES -----------------------

export const getStoragePlacesData = async () : Promise<IInteriorOrganizerPlacesResponse|null> => {
    return await get(`/api/interior/storage-place/get-data`);
};

export const deleteStoragePlace = async (id: number) : Promise<IInteriorOrganizerPlacesResponse|null> => {
    return await deleteJson(`/api/interior/storage-place/delete`, {
        id
    });
};

export const insertStoragePlace = async (
    name: string,
    description: string,
    width: number,
    height: number,
    depth: number,
    is_full: boolean,
) : Promise<IInteriorOrganizerPlacesResponse|null> => {
    return await postJson(`/api/interior/storage-place/insert`, {
        name,
        description,
        width,
        height,
        depth,
        is_full,
    });
};

export const duplicateStoragePlace = async (
    id: number,
) : Promise<IInteriorOrganizerPlacesResponse|null> => {
    return await postJson(`/api/interior/storage-place/duplicate`, {
        id,
    });
};

export const updateStoragePlace = async (
    id: number,
    name: string,
    description: string,
    width: number,
    height: number,
    depth: number,
    is_full: boolean,
) : Promise<IInteriorOrganizerPlacesResponse|null> => {
    return await putJson(`/api/interior/storage-place/update`, {
        id,
        name,
        description,
        width,
        height,
        depth,
        is_full,
    });
};

// --------------- STORAGE ITEMS -----------------------

export const getStorageItemsData = async () : Promise<IInteriorOrganizerItemsResponse|null> => {
    return await get(`/api/interior/storage-item/get-data`);
};

export const deleteStorageItem = async (id: number) : Promise<IInteriorOrganizerItemsResponse|null> => {
    return await deleteJson(`/api/interior/storage-item/delete`, {
        id
    });
};

export const insertStorageItem = async (
    name: string,
    description: string,
    width: number,
    height: number,
    depth: number,
    is_full: boolean,
) : Promise<IInteriorOrganizerItemsResponse|null> => {
    return await postJson(`/api/interior/storage-item/insert`, {
        name,
        description,
        width,
        height,
        depth,
        is_full,
    });
};

export const duplicateStorageItem = async (
    id: number,
) : Promise<IInteriorOrganizerItemsResponse|null> => {
    return await postJson(`/api/interior/storage-item/duplicate`, {
        id,
    });
};

export const updateStorageItem = async (
    id: number,
    name: string,
    description: string,
    width: number,
    height: number,
    depth: number,
    is_full: boolean,
) : Promise<IInteriorOrganizerItemsResponse|null> => {
    return await putJson(`/api/interior/storage-item/update`, {
        id,
        name,
        description,
        width,
        height,
        depth,
        is_full,
    });
};

export const uploadStorageItemAttachment = async (formData: FormData) : Promise<IInteriorOrganizerItemsResponse|null> => {
    return await upload('/api/interior/storage-item/upload', formData);
};

export const deleteStorageItemAttachment = async (
    attachment_id: number,
) : Promise<IInteriorOrganizerItemsResponse|null> => {
    return await deleteJson(`/api/interior/storage-item/delete-attachment`, {
        attachment_id,
    });
};